import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import 'antd/dist/antd.css';
import { Alert } from 'antd';
import { RESOURCE, MESSAGE } from '../../config/constants/alerts';
import { STATUS } from '../../config/constants/states';
import PropTypes from 'prop-types';
import { CLEAR_ERRORS } from '../../state/error/types';

/**
 * Component that returns alert message.
 * @component
 * @returns {Element} React component with error messages
 */
const Alerts = props => {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [severity, setSeverity] = useState('error');
  const [prevError, setPrevError] = useState({
    status: '',
    message: '',
    code: 0,
    resource: '',
    payload: {},
  });

  useEffect(() => {
    /**
     * Evaluate error status and error resourse to set error message
     */
    if (props.error.status >= 400) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
      setSeverity('Error');
      switch (props.error.resource) {
        case RESOURCE.ADMIN_LOGIN:
          setOpen(true);
          setMessage(MESSAGE.ERROR.ADMIN_LOGIN);
          break;
        case RESOURCE.CREATE_CONTRACT:
          setOpen(true);
          setMessage(MESSAGE.ERROR.CREATE_CONTRACT);
          break;
        case RESOURCE.GET_CONTRACT_LIST:
          setOpen(true);
          setMessage(MESSAGE.ERROR.GET_CONTRACT_LIST);
          break;
        case RESOURCE.GET_USER_DATA:
          setOpen(true);
          setMessage(MESSAGE.ERROR.GET_USER_DATA);
          break;
        case RESOURCE.GET_CONTRACT:
          setOpen(true);
          setMessage(MESSAGE.ERROR.GET_CONTRACT);
          break;
        case RESOURCE.SIGN_CONTRACT:
          setOpen(true);
          setMessage(MESSAGE.ERROR.SIGN_CONTRACT);
          break;
        case RESOURCE.DEMUR_CONTRACT:
          setOpen(true);
          setMessage(MESSAGE.ERROR.DEMUR_CONTRACT);
          break;
        case RESOURCE.GET_CONTRACT_DATA_FORM:
          setOpen(true);
          setMessage(MESSAGE.ERROR.GET_CONTRACT_DATA_FORM);
          break;
        case RESOURCE.UPDATE_CONTRACT_FORM_DATA:
          setOpen(true);
          setMessage(MESSAGE.ERROR.UPDATE_CONTRACT_FORM_DATA);
          break;
        case RESOURCE.GET_CONTRACT_PDF:
          setOpen(true);
          setMessage(MESSAGE.ERROR.GET_CONTRACT_PDF);
          break;
        case RESOURCE.CANCEL_CONTRACT:
          setOpen(true);
          setMessage(MESSAGE.ERROR.CANCEL_CONTRACT);
          break;
        case RESOURCE.REJECT_OBJECTION:
          setOpen(true);
          setMessage(MESSAGE.ERROR.REJECT_OBJECTION);
          break;
        case RESOURCE.SAVE_CONTRACT:
          setOpen(true);
          setMessage(MESSAGE.ERROR.SAVE_CONTRACT);
          break;
        case RESOURCE.RESEND_MAIL:
          setOpen(true);
          setMessage(MESSAGE.ERROR.RESEND_MAIL);
          break;
        case RESOURCE.UPDATE_PASSWORD:
          setOpen(true);
          setMessage(MESSAGE.ERROR.UPDATE_PASSWORD);
          break;
        case RESOURCE.CREATE_COUPON:
          setOpen(true);
          setMessage(MESSAGE.ERROR.CREATE_COUPON);
          break;
        case RESOURCE.GET_JURIDICAL_CERT:
          setOpen(true);
          setMessage(MESSAGE.ERROR.GET_JURIDICAL_CERT);
          break;
        case RESOURCE.NOT_SIGN_CONTRACT:
          setOpen(true);
          setMessage(MESSAGE.ERROR.NOT_SIGN_CONTRACT);
          break;
        case RESOURCE.SAVE_NEW_CONTRACT_PDF:
          setOpen(true);
          setMessage(MESSAGE.ERROR.SAVE_NEW_CONTRACT_PDF);
          break;
        case RESOURCE.SAVE_DRAFT:
          setOpen(true);
          setMessage(MESSAGE.ERROR.SAVE_DRAFT);
          break;
        default:
          setOpen(false);
          setMessage(MESSAGE.ERROR.DEFAULT);
          break;
      }
    } else if (props.error.status === '' && prevError.status === STATUS.LOADING) {
      setSeverity('Success');
      switch (prevError.resource) {
        case RESOURCE.REGISTER:
          setOpen(true);
          setMessage(MESSAGE.SUCCESS.REGISTER);
          break;
        case RESOURCE.CHANGE_PASS:
          setOpen(true);
          setMessage(MESSAGE.SUCCESS.CHANGE_PASS);
          break;
        default:
          setOpen(false);
          setMessage(MESSAGE.SUCCESS.DEFAULT);
          break;
      }
    }
    setPrevError(props.error);
  }, [props.error]);

  return (
    <>
      {open &&
        <>
          {severity === 'Error'
            ? <Alert className="mb-2" message={severity} description={message} type='error' showIcon closable afterClose={() => { props.clearErrors(); setOpen(false); }} />
            : <Alert className="mb-2" message={severity} description={message} type='success' showIcon closable />
          }
        </>
      }
    </>
  );
};

Alerts.propTypes = {
  /**
   * Object with API response status
   */
  error: PropTypes.object.isRequired,
  clearErrors: PropTypes.func.isRequired,
};

const data = state => ({
  user: state.user.user,
  isLoggedIn: state.user.isLoggedIn,
  error: state.error,
});

const actions = (dispatch) => ({
  clearErrors: () => dispatch({ type: CLEAR_ERRORS }),
});

export default connect(data, actions)(Alerts);